/**
 * @generated SignedSource<<e61d7fca72c469034ed9f10bd941437a>>
 * @relayHash 2fd699e8c6cbd7b402861ba79f554fc4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 80fd74fb421fc5a23f04f5fc0122aead61962b88cdb46df27adb91f246f4d475

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraProjectStatus = "ACTIVE" | "ARCHIVED" | "DELETED" | "%future added value";
export type servicesTrialSprintBoardProjectDataQuery$variables = {
  projectAri: string;
};
export type servicesTrialSprintBoardProjectDataQuery$data = {
  readonly jira: {
    readonly jiraProject: {
      readonly boards: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly boardId: AGG$Long | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly key: string;
      readonly status: JiraProjectStatus | null | undefined;
      readonly tmpBoardId: AGG$Long | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type servicesTrialSprintBoardProjectDataQuery = {
  response: servicesTrialSprintBoardProjectDataQuery$data;
  variables: servicesTrialSprintBoardProjectDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "projectAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "status"
},
v3 = {
  "kind": "ScalarField",
  "name": "key"
},
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "boardId"
},
v6 = {
  "kind": "ScalarField",
  "name": "tmpBoardId"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "servicesTrialSprintBoardProjectDataQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProject",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "args": (v4/*: any*/),
                "concreteType": "JiraBoardConnection",
                "kind": "LinkedField",
                "name": "boards",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraBoardEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraBoard",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "boards(first:1)"
              },
              (v6/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "servicesTrialSprintBoardProjectDataQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProject",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "args": (v4/*: any*/),
                "concreteType": "JiraBoardConnection",
                "kind": "LinkedField",
                "name": "boards",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraBoardEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraBoard",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v7/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "boards(first:1)"
              },
              (v6/*: any*/),
              (v7/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "80fd74fb421fc5a23f04f5fc0122aead61962b88cdb46df27adb91f246f4d475",
    "metadata": {},
    "name": "servicesTrialSprintBoardProjectDataQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "68675099be034483c98781f370d01a4f";

export default node;
